const formatSortCode = (value) => {
  if (!value) return ''
  const text = value.split('-').join('')
  return text.match(/.{1,2}/g).join('-')
}

export default formatSortCode
